import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import ProjectConfigurationScreen from './ProjectConfigurationScreen';
import ProjectTypeDetailsScreen from '../project-types/ProjectTypeDetailsScreen';
import ProjectSubTypeDetailsScreen from '../project-sub-types/ProjectSubTypeDetailsScreen';
import ProjectSettingsDataCategoryScreen from '../settings/ProjectSettingsDataCategoryScreen';

export default function ProjectConfigurationRouter() {
	return (
		<Routes>
			<Route
				path="/"
				element={<Navigate to="/project-configuration/types" replace />}
			/>
			<Route path="/types" element={<ProjectConfigurationScreen />} />
			<Route
				path="/types/:configurationId"
				element={<ProjectTypeDetailsScreen />}
			/>
			<Route path="/sub-types" element={<ProjectConfigurationScreen />} />
			<Route
				path="/sub-types/:projectSubTypeId"
				element={<ProjectSubTypeDetailsScreen />}
			/>
			<Route path="/data" element={<ProjectConfigurationScreen />} />
			<Route
				path="/data/:configurationId"
				element={<ProjectSettingsDataCategoryScreen />}
			/>
		</Routes>
	);
}

